module.exports = "/_next/static/images/64024fa1d2de423be307d3e2ff2a890f-phone-with-app-open-and-card@1x-lg.jpg";